<template>
  <div :class="wrapClass">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      :class="buttonClass"
      :color="parsedColor"
      min-width="200px"
      height="48px"
      depressed
      tile
      :type="type"
      :style="cssVars"
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    dark: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "secondary",
    },
    textColor: {
      type: String,
      default: "#ffffff",
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    wrapClass() {
      const alignClassOptions = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
      };

      const wrapClass = ["d-flex", alignClassOptions[this.align]];

      return wrapClass;
    },
    buttonClass() {
      const buttonClass = [
        "text-body-1 text-md-subtitle-1 text-none font-weight-bold px-8 button-widget",
      ];

      return buttonClass;
    },
    parsedColor() {
      return this.dark ? "white" : this.color;
    },
    cssVars() {
      return {
        "--text-color": this.textColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.button-widget {
  border-radius: 50px !important;
  color: var(--text-color) !important;
}
</style>
